import React from "react";

const Image = ({ src, alt, classname }) => {
  return (
    <div>
      <img src={src} alt={alt} className={classname} />
    </div>
  );
};

export default Image;
